export const DETAILED_CYCLE_TIME_REPORT_TITLE =
  'Detailed Cycle Time Report with Exceptions';

export const DETAILED_CYCLE_TIME_REPORT_MESSAGE =
  'Provides a detailed breakdown of claims and their cycle times using the same criteria as the Cycle Time screen - this report also includes Exceptions that show why jobs do NOT appear on the Cycle Time Screen (Version 2)';

export const DETAILED_CYCLE_TIME_REPORT_GRID_TITLE =
  'DetailedCycleTimeReport_wEX_V2';

export const columnsList = (showExcep: boolean): any[] => [
  { name: 'repairer', title: 'Repairer', width: '200' },
  { name: 'stream', title: 'Stream' },
  { name: 'manufacturer', title: 'Manufacturer' },
  { name: 'activeWebID', title: 'ActiveWebID' },
  { name: 'registration', title: 'Registration' },
  { name: 'hours', title: 'Hours' },
  { name: 'fnolToOnsite', title: 'FNOL to On Site' },
  { name: 'onSiteToStarted', title: 'Onsite to Started' },
  { name: 'startedToCompleted', title: 'Started to Completed' },
  { name: 'completedToDelivered', title: 'Completed to Delivered' },
  { name: 'keyToKey', title: 'Key to Key' },
  {
    name: showExcep ? 'fnolToDelivered' : 'fnolToInvoiced',
    title: showExcep ? 'FNOL to Delivered' : 'FNOL to Invoiced',
  },
  { name: 'affectsCycleTime', title: 'Affects CycleTime' },
  { name: 'createdDTG', title: 'Created DTG', type: 'date' },
];

export const mockedData = [
  {
    repairer: "DLG Auto Services (Bristol)",
    siteCode: "DLG_BRI",
    repairerGroup: "DLGAS",
    activeWebID: "DLG_BRI.25731301",
    registration: "RE05HKB",
    stream: "NARGDLGCH",
    manufacturer: "Volvo",
    fnolToOnsite: 1,
    onSiteToStarted: 2,
    startedToCompleted: 3,
    completedToDelivered: 4,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 6,
    hours: 7,
    affectsCycleTime: 9,
    createdDTG: "2024-06-07T15:23:28"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2282",
    registration: "HJ69FEX",
    stream: "NARGDLGCH",
    manufacturer: "Unknown",
    fnolToOnsite: 8,
    onSiteToStarted: 11,
    startedToCompleted: 12,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 6,
    hours: 45,
    affectsCycleTime: 0,
    createdDTG: "2024-06-07T14:25:18"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2278",
    registration: "Y2",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.8,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 20,
    affectsCycleTime: 0,
    createdDTG: "2024-06-05T13:11:29"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2279",
    registration: "R2",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.8,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 9,
    affectsCycleTime: 0,
    createdDTG: "2024-06-05T13:17:34"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2287",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 3,
    affectsCycleTime: 0,
    createdDTG: "2024-06-19T15:33:02"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2288",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3.1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:03:35"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2305",
    registration: "GU07CHZ",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 1.1,
    onSiteToStarted: 0.1,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0.1,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-07-17T09:34:22"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2307",
    registration: "GU07CHZ",
    stream: "RSADEF",
    manufacturer: "BMW",
    fnolToOnsite: 1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-07-22T14:22:02"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2308",
    registration: "JMN258N",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.9,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-07-22T14:22:02"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2289",
    registration: "R1",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3.1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:09:39"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2290",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:27:49"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2291",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:33:54"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2296",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 500,
    affectsCycleTime: 0,
    createdDTG: "2024-06-27T07:39:01"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2297",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5000,
    affectsCycleTime: 0,
    createdDTG: "2024-06-27T07:51:10"
  },
  {
    repairer: "Pinetree Repairer1",
    siteCode: "EVAL_DEV1",
    repairerGroup: "PINETREE",
    activeWebID: "EVAL_DEV1.1532",
    registration: "DLG02API",
    stream: "DLGDLINE",
    manufacturer: "Unknown",
    fnolToOnsite: 6.1,
    onSiteToStarted: 0.9,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0.9,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-08-07T15:25:32"
  },
];